// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscription-root__Profile_3tO4Y h2 {\n  margin-bottom: 20px;\n}\n.subscription-root__Profile_3tO4Y h4 {\n  margin-bottom: 10px;\n}\n.space-item__Profile_36tb1 {\n  background-color: hsl(0, 0%, 90%);\n  padding: 5px;\n  min-width: 200px;\n  display: flex;\n  justify-content: center;\n  font-size: 14px;\n  margin-right: 30px;\n}\n.space-wrap__Profile_3sGkI {\n  margin-bottom: 40px;\n}\n.header__Profile_2Al8v {\n  display: flex;\n  justify-content: space-between;\n}\n.btn-cancel__Profile_3bTNV {\n  margin-right: 0;\n}\n", ""]);
// Exports
exports.locals = {
	"subscription-root": "subscription-root__Profile_3tO4Y",
	"subscriptionRoot": "subscription-root__Profile_3tO4Y",
	"space-item": "space-item__Profile_36tb1",
	"spaceItem": "space-item__Profile_36tb1",
	"space-wrap": "space-wrap__Profile_3sGkI",
	"spaceWrap": "space-wrap__Profile_3sGkI",
	"header": "header__Profile_2Al8v",
	"btn-cancel": "btn-cancel__Profile_3bTNV",
	"btnCancel": "btn-cancel__Profile_3bTNV"
};
module.exports = exports;
